import React from 'react';
import { Stack, Box } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const requisitos = [
  "Ser hijo, hija o familiar de un(a) colaborador(a) de las empresas del Consejo Mexicano de Negocios (CMN).",
  "Ser estudiante regular de cualquier institución de educación media superior, pública o privada y de cualquier semestre.",
  "Tener un promedio acumulado hasta el periodo inmediato anterior mínimo de 7.0, esto debe coincidir con la constancia académica solicitada.",
  "Ser menor de edad durante la duración del programa (haber nacido despues del 1 de diciembre del 2006)",
  "No estar postulando ni postular (durante la vigencia del programa LeM MS) a otro programa que se desarrolle en las mismas fechas o que evite, por cualquier motivo, que el o la estudiante cumpla a cabalidad sus tareas asignadas.",
];

export default function LemMs() {
  return (
    <Stack sx={{ mt: 2}}>
    <Accordion sx={{ backgroundColor: '#268c83', color: 'white' }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />} aria-controls="panel1a-content" id="panel1a-header">
          <Box sx={{ fontSize: "20px", fontWeight: 'bold' }}>Requisitos</Box>
        </AccordionSummary>
        <AccordionDetails>
          <Stack component="ol" sx={{ textAlign: 'left' }} spacing={2}>
          {requisitos.map((req, index) => (
            <Stack direction="row" spacing={1} key={`req-${index}`}>
              <Box sx={{ fontWeight: 'bold' }}>{index + 1}.</Box>
              <Box sx={{ ml: 2 }}>{req}</Box>
            </Stack>
          ))}
          </Stack>
        </AccordionDetails>
      </Accordion>
    </Stack>
  );
}
